// Build information for deployment verification
const BUILD_TIMESTAMP = new Date().toISOString().slice(0, 16).replace('T', '_');
const GIT_SHA = import.meta.env.VITE_GIT_SHA || 'local';

export const BUILD_ID = `${BUILD_TIMESTAMP}_${GIT_SHA.slice(0, 7)}`;
export const APP_ENV = import.meta.env.MODE || 'development';

export function logBuildInfo() {
  console.info(`[OneForm] Build ${BUILD_ID} (${APP_ENV})`);
}
